import React, { lazy } from "react";
import { Outlet, useLocation, useParams, Navigate } from "react-router-dom";
import { ModalProvider } from "../../context/ModalContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { InitialLoadingProvider } from "@/context/InitialLoadingContext";
const NotFound = lazy(() => import("@/pages/NotFound"));

export const RouteWrapper = () => {
  const { pathname } = useLocation();
  const { lang } = useParams();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const queryClient = new QueryClient();

  // Restrict lang to "en" or undefined
  if (lang && lang !== "en") {
    return (
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <LanguageProvider>
            <InitialLoadingProvider>
              <ModalProvider>
                <NotFound />
              </ModalProvider>
            </InitialLoadingProvider>
          </LanguageProvider>
        </AuthProvider>
      </QueryClientProvider>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <LanguageProvider>
          <InitialLoadingProvider>
            <ModalProvider>
              <Outlet />
            </ModalProvider>
          </InitialLoadingProvider>
        </LanguageProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
};
